import { BBBackendQueryOptions, type User } from "@bidbattles/bloks/lib/rapace";
import { useSuspenseQuery } from "@tanstack/react-query";

export function useUser(): User | null {
	const { data } = useSuspenseQuery(BBBackendQueryOptions.me({}));

	return data ?? null;
}

export function useUserReferralCode(): string {
	const { data } = useSuspenseQuery(
		BBBackendQueryOptions.fetchReferralCode({}),
	);
	return data;
}
